module.exports = __webpack_public_path__ + "static/media/vishing.df1b183d.png";